import axios from "axios";

/**
 * JoinSpark（join-creative-v3）三方绑定接口。
 * 与 pandagpt 自身的 $axios 不同：$axios 会走 HMAC 签名（utils/axios.js），而 JoinSpark
 * 三方绑定接口使用独立的鉴权/返回结构，因此这里单独创建一个 axios 实例。
 *
 * - 开发环境：baseURL 为 /joinspark-api，走 vue.config.js 里的代理（转发到 cnc.emkol.cn）
 * - 生产环境：直连 VUE_APP_JOINSPARK_API_URL（cnc.joindigital.cn）
 */
const service = axios.create({
  baseURL: process.env.VUE_APP_JOINSPARK_API_URL || "/joinspark-api",
  timeout: 10 * 60 * 1000
});

// 统一返回响应体本身（JoinSpark 返回 {code, msg, data}），
// 使调用方可以直接读 res.code / res.data，与 pandagpt 现有 $axios 用法保持一致。
service.interceptors.response.use(response => response.data, error => Promise.reject(error));

/**
 * 检测三方绑定状态
 * @param {Object} data { platform, openid, mobile_prefix, mobile_number, team_id? }
 * @returns {Promise<{code:number;msg:string;data:{bound:boolean;check_token?:string;phone?:string}}>}
 */
export const checkBinding = data => service.post("/api/v1/auth/third/check_binding", data);

/**
 * 三方平台授权绑定（单账号模式 / 团队授权模式）
 * @param {Object} data { platform, openid, pr_username?, mobile_prefix, mobile_number, team_id?, team_name?, members? }
 * @returns {Promise<{code:number;msg:string;data:{check_token:string}}>}
 */
export const authorize = data => service.post("/api/v1/auth/third/authorize", data);

/**
 * 快捷登陆
 * @param {Object} data { platform, check_token }
 * @returns {Promise<{code:number;msg:string;data:{user_info:Object, token:string}}>}
 */
export const quickLogin = data => service.post("/api/v1/auth/third/quick_login", data);